import { basePostAPICall, getAPICall, postAPICall } from './BaseAPI';

export const getAddressesData = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/getaddressesdata/', payload,  cb);
}

export const searchAddress = async (str:any, storeId:number, cb = (jR, s, e)=>{}) => {
  const encodedStr = encodeURIComponent(str);
  return await getAPICall('address/search/'+encodedStr+'/'+storeId, cb);
}

// USPS Address Lock-in: live typeahead of verified US addresses (Mapbox-backed,
// proxied server-side). Used in admin order flows when a brand has
// require_usps_address enabled. Pass optional comma-separated zips to restrict.
// Also searches named places/complexes (e.g. condo communities), not just
// street addresses. Suggestions do NOT include lat/lng — call
// retrieveUspsAddress() with the picked suggestion's mapbox_id to resolve GPS.
export const searchUspsAddress = async (str:any, cb = (jR, s, e)=>{}, zips?: string, sessionToken?: string) => {
  const encodedStr = encodeURIComponent(str);
  let route = 'address/usps-suggest?q='+encodedStr;
  if (zips) route += '&zips=' + encodeURIComponent(zips);
  if (sessionToken) route += '&session_token=' + encodeURIComponent(sessionToken);
  return await getAPICall(route, cb);
}

// Resolves a picked USPS suggestion's mapbox_id into full details (incl.
// lat/lng). Pass the same sessionToken used for the preceding
// searchUspsAddress call to correctly group Mapbox billing into one session.
export const retrieveUspsAddress = async (mapboxId: string, cb = (jR, s, e)=>{}, sessionToken?: string) => {
  let route = 'address/usps-retrieve?id=' + encodeURIComponent(mapboxId);
  if (sessionToken) route += '&session_token=' + encodeURIComponent(sessionToken);
  return await getAPICall(route, cb);
}

// Lightweight session token generator (grouping-only, not cryptographic) for
// Mapbox Search Box API billing — pair one token across a suggest -> retrieve
// cycle, then generate a new one for the next search.
export const generateSessionToken = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getForecastingData = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('forecasting/getsummary/', payload, cb);
}

export const uploadForecastFiles = async (payload, cb = (jR, s, e)=>{}) => {
  return await basePostAPICall('forecasting/uploadforecastfiles/', {}, payload, cb);
}

export const getForecastFilesData = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('forecasting/getforecastfilesdata/', payload, cb);
}

export const getUniqueFilenames = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('forecasting/getuniquefilenames/', cb);
}

export const getSheetsByFilename = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('forecasting/getsheetsbyfilename/', payload, cb);
}

export const getOrderPotentialData = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('marketing/orderpotential/', payload, cb);
}

export const updateAddress = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/updateaddress', payload, cb);
};

export const updateCoordinates = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/updatecoordinates', payload, cb);
};

export const createAddress = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/createaddress', payload, cb);
};

export const deleteAddress = (id, cb=(jR, s, e)=>{}) => {
  const payload = { id };
  postAPICall('alladdresses/deleteaddress', payload, cb);
}

export const getStreets = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('alladdresses/getstreets/', cb);
}

export const getPlantations = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('alladdresses/getplantations/', cb);
}
export const getPropertyNames = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('alladdresses/getpropertynames/', cb);
}

export const getPlantationsData = async (belongs_to?, cb = (jR, s, e)=>{}) => {
  if (typeof belongs_to === 'function') {
    return await getAPICall('alladdresses/getplantationsdata/', belongs_to);
  }

  let route = 'alladdresses/getplantationsdata/';
  if (belongs_to) {
    route += '?belongs_to=' + belongs_to;
  }
  return await getAPICall(route, cb);
}

export const createPlantation = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/createplantation', payload, cb);
};

export const updatePlantation = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/updateplantation', payload, cb);
};

export const deletePlantation = (id, cb=(jR, s, e)=>{}) => {
  const payload = { id };
  postAPICall('alladdresses/deleteplantation', payload, cb);
}

export const getStreetsData = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('alladdresses/getstreetsdata/',  cb);
}

export const createStreet = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/createstreet', payload, cb);
};

export const updateStreet = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/updatestreet', payload, cb);
};

export const deleteStreet = (id, cb=(jR, s, e)=>{}) => {
  const payload = { id };
  postAPICall('alladdresses/deletestreet', payload, cb);
}

export const getPropertyNamesData = async (cb = (jR, s, e)=>{}) => {
  return await getAPICall('alladdresses/getpropertynamesdata/',  cb);
}

export const createPropertyName = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/createpropertyname', payload, cb);
};

export const updatePropertyName = async (payload, cb=(jR, s, e)=>{}) => {
  return await postAPICall('alladdresses/updatepropertyname', payload, cb);
};

export const deletePropertyName = (id, cb=(jR, s, e)=>{}) => {
  const payload = { id };
  postAPICall('alladdresses/deletepropertyname', payload, cb);
}